import { getLanguageIETF } from '@constants/locales';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useFormatedDate = (
    options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    },
) => {
    const { i18n } = useTranslation();
    const IETF = getLanguageIETF(i18n.language);

    const dateFormatter = useMemo(() => {
        return new Intl.DateTimeFormat(IETF, options);
    }, [IETF, options]);

    const formatDate = (date: number | Date | undefined) => {
        if (!date) return;
        return dateFormatter.format(date);
    };

    return { formatDate };
};
